export default {
  submitButton: {
    id: 'profile_page_banking_details_tab_modal_submit_button',
    defaultMessage: 'Add details',
  },
  modalTitle: {
    id: 'profile_page_banking_details_tab_modal_title',
    defaultMessage: 'Banking details',
  },
  cancelButton: {
    id: 'profile_page_banking_details_tab_modal_cancel_button',
    defaultMessage: 'Cancel',
  },
  accountNumberInputLabel: {
    id: 'profile_page_banking_details_tab_edit_account_number_name_input_label',
    defaultMessage: 'Account number',
  },
  routingNumberInputLabel: {
    id: 'profile_page_banking_details_tab_edit_routing_number_input_label',
    defaultMessage: 'Routing number',
  },
  required: {
    id: 'profile_page_banking_details_tab_edit_required',
    defaultMessage: 'This field is required',
  },
  bankingDetailsUpdatedToastSuccessTitle: {
    id: 'profile_page_banking_details_tab_success_toast_title',
    defaultMessage: 'Details updated ✔️',
  },
  bankingDetailsUpdatedToastSuccessContent: {
    id: 'profile_page_banking_details_tab_success_toast_content',
    defaultMessage: 'You’re that much closer to selling on Back Market.',
  },
  updatingBankingDetails: {
    id: 'profile_page_banking_details_tab_updating_banking_details',
    defaultMessage: 'Updating your banking details...',
  },
}
